<ng-shipper-profile-dialog
  *ngIf="(store$ | async) as store"
  [data]="store.shipperProfiles"
  [loading]="store.loadingShippers"
  (loadShipment)="closeDialog($event)"
></ng-shipper-profile-dialog>
